import { createApp } from 'vue'
import App from './App.vue'
import { store, key } from './store'
import router from './router'
import ('./icons')
import svgIcon from './components/svgIcon.vue'
import svgElement from './components/svgElement.vue'
import '@icon-park/vue-next/styles/index.css'
import 'prosemirror-view/style/prosemirror.css'
import 'animate.css'

import Vue3ColorPicker from "vue3-colorpicker"
import "vue3-colorpicker/style.css"
import '@/assets/styles/prosemirror.scss'
import '@/assets/styles/antd.scss'
import Icon from '@/plugins/icon'
import Component from '@/plugins/component'
import Directive from '@/plugins/directive'
import V3waterfall from 'v3-waterfall'
import 'v3-waterfall/dist/style.css'
import '@/assets/styles/global.scss'
import lazyPlugin from 'vue3-lazy'
import {
  InputNumber,
  Divider,
  Button,
  Tooltip,
  Popover,
  Slider,
  Select,
  Switch,
  Form,
  Radio,
  Input,
  Modal,
  Dropdown,
  Menu,
  Checkbox,
  Drawer,
  Spin,
  Card,
  Cascader,
  Upload,
  Image,
  Tabs,
  Pagination,
  BackTop,
  Skeleton,
  Progress,
} from 'ant-design-vue'

import LoginModal from '../src/views/components/login/index.vue'
import EmptyBox from './components/emptyBox.vue'

const app = createApp(App)

app.component('BackTop', BackTop)
app.component('InputNumber', InputNumber)
app.component('Divider', Divider)
app.component('Button', Button)
app.component('Form', Form)
app.component('FormItem', Form.Item)
app.component('Upload', Upload)
app.component('ButtonGroup', Button.Group)
app.component('Card', Card)
app.component('Image', Image)
app.component('Tooltip', Tooltip)
app.component('Popover', Popover)
app.component('Slider', Slider)
app.component('Select', Select)
app.component('SelectOption', Select.Option)
app.component('SelectOptGroup', Select.OptGroup)
app.component('Switch', Switch)
app.component('Radio', Radio)
app.component('RadioGroup', Radio.Group)
app.component('RadioButton', Radio.Button)
app.component('Input', Input)
app.component('InputGroup', Input.Group)
app.component('InputSearch', Input.Search)
app.component('Modal', Modal)
app.component('Dropdown', Dropdown)
app.component('Menu', Menu)
app.component('MenuItem', Menu.Item)
app.component('Tabs', Tabs)
app.component('TabPane', Tabs.TabPane)
app.component('SubMenu', Menu.SubMenu)
app.component('ItemGroup', Menu.ItemGroup)
app.component('menuDivider', Menu.Divider)
app.component('Checkbox', Checkbox)
app.component('Drawer', Drawer)
app.component('Spin', Spin)
app.component('Cascader', Cascader)
app.component('MoadlConfirm', Modal.confirm)
app.component('Pagination',Pagination)
app.component('svg-icon', svgIcon)
app.component('svgElement', svgElement)
app.component('LoginModal', LoginModal)
app.component('EmptyBox', EmptyBox)
app.component('UploadDragger', Upload.Dragger)
app.component('Skeleton',Skeleton)
app.component('Progress',Progress)
app.use(Icon)
app.use(Component)
app.use(Directive)
app.use(V3waterfall)
app.use(router)
app.use(store, key)
app.use(Vue3ColorPicker)
app.use(lazyPlugin, {
  preLoad: 1,
  attempt: 2,
  loading: require('@/assets/images/empty.png'), // 图片加载时默认图片
  error: require('@/assets/images/empty.png')// 图片加载失败时默认图片
})
app.mount('#app')
